/** Matches API `settings::RegularRateAfterExpiry` (camelCase on the wire). */
export interface RegularRateAfterExpiry {
  enabled: boolean
}

export function parseRegularRateAfterExpiry(
  json: unknown
): RegularRateAfterExpiry | undefined {
  if (!json || typeof json !== 'object') {
    return undefined
  }

  const record = json as Record<string, unknown>
  if (record['enabled'] === undefined) {
    return undefined
  }

  return {
    enabled: Boolean(record['enabled']),
  }
}
